import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { style: {"margin":"-7px 0 -13px 0"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "fs-14 d-block mb-4" }, "On-Time Delivery", -1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isClient)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              type: "pie",
              height: "180",
              options: _ctx.onTimeDelivery,
              series: _ctx.delivery
            }, null, 8, ["options", "series"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}